import Marquee from './Marquee';
import { WipeLink } from './Wipe';
import { CHAPTERS } from '../data/site';
import { FadeUp } from './Reveal';

const Footer = () => (
  <footer className="bg-brand-black text-paper" data-testid="site-footer">
    <Marquee
      items={['Clarity', 'Control', 'Growth', 'Kirana', 'System', 'Community', 'Trust', 'Retail Saarthi']}
      className="border-b border-white/10 py-6 text-2xl md:text-4xl font-light uppercase tracking-tight text-paper/80"
    />
    <div className="px-5 md:px-10 lg:px-24 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-12">
      <FadeUp className="md:col-span-6">
        <img src="/assets/logo/alt1.png" alt="Project logo" className="h-10 w-auto mb-8" />
        <p className="text-xs uppercase tracking-[0.3em] text-paper/50 mb-6">A Graduation Project</p>
        <p className="text-3xl md:text-5xl font-light leading-[1.02] tracking-tight">
          Designing for the Next Phase of India's Offline Retail
        </p>
        <p className="mt-6 text-sm md:text-base text-paper/60 max-w-md leading-relaxed">
          Written and designed by Aditya Ranka, under the guidance of Prof. Shhyam Prajapati.
          Unitedworld Institute of Design, Karnavati University, Gandhinagar, 2026.
        </p>
      </FadeUp>
      <FadeUp delay={0.1} className="md:col-span-3">
        <p className="text-xs uppercase tracking-[0.3em] text-paper/50 mb-6">Chapters</p>
        <ul className="space-y-3">
          {CHAPTERS.map((c) => (
            <li key={c.slug}>
              <WipeLink
                to={`/chapter/${c.slug}`}
                data-testid={`footer-chapter-${c.slug}`}
                className="text-sm md:text-base font-semibold text-paper/80 transition-colors duration-300 hover:text-paper"
              >
                <span style={{ color: c.color }} className="mr-3">{c.n}</span>
                {c.title}
              </WipeLink>
            </li>
          ))}
        </ul>
        <p className="text-xs uppercase tracking-[0.3em] text-paper/50 mt-10 mb-4">Beyond the Book</p>
        <ul className="space-y-3">
          <li>
            <WipeLink to="/saarthi" data-testid="footer-saarthi-link" className="text-sm md:text-base font-semibold text-paper/80 transition-colors duration-300 hover:text-paper">
              <span className="text-brand-pink mr-3">CS</span>Retail Saarthi, Case Study
            </WipeLink>
          </li>
          <li>
            <WipeLink to="/about" data-testid="footer-author-link" className="text-sm md:text-base font-semibold text-paper/80 transition-colors duration-300 hover:text-paper">
              <span className="text-brand-pink mr-3">A</span>About the Author
            </WipeLink>
          </li>
        </ul>
      </FadeUp>
      <FadeUp delay={0.15} className="md:col-span-3">
        <p className="text-xs uppercase tracking-[0.3em] text-paper/50 mb-6">Connect</p>
        <ul className="space-y-3 text-sm md:text-base font-semibold text-paper/80">
          <li><a href="mailto:contact@adityarankaa.com" data-testid="footer-mail-link" className="transition-colors duration-300 hover:text-paper">contact@adityarankaa.com</a></li>
          <li><a href="tel:+919826025454" data-testid="footer-phone-link" className="transition-colors duration-300 hover:text-paper">[IN] +91 98260 25454</a></li>
          <li><a href="https://www.behance.net/adityarka" target="_blank" rel="noopener noreferrer" data-testid="footer-behance-link" className="transition-colors duration-300 hover:text-paper">Behance</a></li>
          <li><a href="https://www.linkedin.com/in/adityarka" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin-link" className="transition-colors duration-300 hover:text-paper">LinkedIn</a></li>
        </ul>
        <p className="mt-6 text-xs uppercase tracking-[0.25em] text-paper/40" data-testid="footer-location">Indore, India</p>
        <p className="mt-8 text-xs text-paper/40 leading-relaxed">
          Written & designed with intent,<br />for the shops that raised us.
        </p>
      </FadeUp>
    </div>
    <div className="px-5 md:px-10 lg:px-24 pb-10 flex flex-col md:flex-row justify-between gap-4 text-[11px] uppercase tracking-[0.25em] text-paper/40">
      <span>Vol. 1 of 1, Bachelors of Design (Hons.) Product Design</span>
      <span data-testid="footer-copyright">© 2026 Aditya Ranka · All rights reserved & protected</span>
      <span>"All limitations are self imposed."</span>
    </div>
  </footer>
);

export default Footer;
